/**
 * @file コンポーネント：フル動画ページタイムラインシェーマ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledList = styled.ul`
    margin-top: 8px;
`;

export const StyledListImage = styled.img`
    width: 100%;
`;

export const StyledListItem = styled.li`
    position: relative;
    margin-bottom: 8px;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const StyledPopupSchemaButton = styled.a`
    opacity: 0.7;
    position: absolute;
    top: 16px;
    right: 16px;
    background-color: transparent;
    color: #ffffff;
    font-size: 16px;
    line-height: 16px;
    text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
`;
